export default __webpack_public_path__ + "static/media/orange-checkmark-delta.dd4075a6.svg";